
import { getCommonHead } from "@/utils/head"
import topContent from "@/components/topContent/topContent"
import bottom from "@/components/bottom"
export default {
  components: {
    topContent,
    bottom
  },
  head() {
    return getCommonHead()
  }
}
